import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.25 23.25 5.53 12.53a.75.75 0 0 1 0-1.06L16.25.75"
    }, null, -1)
  ]));
}
const arrowChevronLeft = { render };
export {
  arrowChevronLeft as default,
  render
};
//# sourceMappingURL=arrow-chevron-left.svg.js.map
